import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { PurchaseFormService } from '../../../../services/purchase-form.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Language } from '../../../../shared/models/language';
import { isValidPhoneNumber } from 'libphonenumber-js';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class ContactCardComponent implements OnInit {
  @ViewChild('contactForm') contactForm!: NgForm;
  @ViewChild('phoneNumberInput') phoneNumberInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('emailInput') emailInputRef!: ElementRef<HTMLInputElement>;

  contactMode: 'phone' | 'email' = 'phone';
  phoneNumber: string = '';
  emailAddress: string = '';
  countryCode: string = '+45';

  constructor(
    private formService: PurchaseFormService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    const savedFormState = this.formService.getContactDetails();

    if (savedFormState && (savedFormState.phoneNumber || savedFormState.emailAddress)) {
      this.contactMode = savedFormState.type;
      this.phoneNumber = savedFormState.phoneNumber;
      this.emailAddress = savedFormState.emailAddress;
      this.countryCode = savedFormState.countryCode ?? '+45';
    } else {
      if (this.translateService.getCurrentLang() === Language.English) {
        this.contactMode = 'email';
      }
    }
  }

  switchMode(mode: 'phone' | 'email'): void {
    this.contactMode = mode;
    if (mode === 'phone') {
      this.emailAddress = '';
    } else {
      this.phoneNumber = '';
      this.countryCode = '+45';
    }
    this.validateContactControl();

    setTimeout(() => {
      if (mode === 'phone') {
        this.phoneNumberInputRef?.nativeElement.focus();
      } else {
        this.emailInputRef?.nativeElement.focus();
      }
    }, 0);
  }

  validateContactControl(): void {
    const isValid = this.contactMode === 'phone'
      ? this.validatePhone()
      : this.validateEmail();

    this.formService.setContactDetails({
      type: this.contactMode,
      isValid,
      countryCode: this.countryCode,
      phoneNumber: this.phoneNumber,
      emailAddress: this.emailAddress
    });
  }

  private validatePhone(): boolean {
    try {
      return isValidPhoneNumber(`${this.countryCode}${this.phoneNumber}`);
    } catch {
      return false;
    }
  }

  private validateEmail(): boolean {
    return this.contactForm?.controls['emailAddress']?.valid ?? false;
  }

  get isPhoneInvalid(): boolean {
    const control = this.contactForm?.controls['phoneNumber'];
    return (control?.dirty || control?.touched)
      ? !this.validatePhone()
      : false;
  }

  get isEmailInvalid(): boolean {
    const control = this.contactForm?.controls['emailAddress'];
    return !!(control?.invalid && (control?.dirty || control?.touched));
  }

  hideKeyboard(input: HTMLInputElement) {
    input.blur();
  }
}
